import { DefaultError, useQuery } from '@tanstack/react-query';
import { apiClient } from 'utils';
import { useResponseHandler } from 'utils/service/responseHandler';
import { ITopTrackEarnings, ITrackEarnings, ITrackEarningsQuery } from './types';

export const useGetTrackEarnings = (
  query: ITrackEarningsQuery,
  enabled?: boolean
) => {
  const { responseHandler } = useResponseHandler();
  return useQuery<ITrackEarnings[], DefaultError>({
    queryKey: ['track-earnings', query],
    async queryFn() {
      const response = await apiClient({
        method: 'GET',
        url: `Statistics/Track/Earnings`,
        params: query,
      });

      return responseHandler(response, {
        groupName: `useGetTrackEarnings`,
        onNotFound: () => {},
      });
    },
    enabled,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
};
